module.exports = __webpack_public_path__ + "img/BS15.95f46652.svg";